import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { CircularProgress, Typography } from "@material-ui/core";
import { baseUrlRate, LOCAL_STORAGE_KEY } from "../../../config";
import { getUserData } from "../../common/utility/Utils";
import { path } from "../../../order_managment/constants/apiPath";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import { useState } from "react";
import routeConstant from "../../../route/compoent/routeConstant";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { StoreContext } from "../../../store/Provider";
import Button from "@mui/material/Button";
import { async } from "q";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function WarningModal({
  dailogueOpen,
  setDailogueOpen,
  freightValue,
}) {
  const handleClose = () => {
    setDailogueOpen(false);
  };
  const navigate = useNavigate();
  const location = useLocation();
  console.log(freightValue, "freightValue");

  const fetchdata = async () => {};

  return (
    <Dialog
      fullWidth
      maxWidth={"md"}
      open={dailogueOpen}
      TransitionComponent={Transition}
      keepMounted
      // onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {freightValue.isHazardous === "true" ? (
            <>
              <Typography>Attention!</Typography>
              <Typography>
                {" "}
                Kindly contact MTS Logistics to get the rate on Hazardous
                commodity opted by you.
              </Typography>
            </>
          ) : (
            // <Typography>Are you sure ?</Typography>
            <Typography>Do you want to proceed with Quote Creation?</Typography>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          style={{ minWidth: "7rem", color: "#fff", background: "red" }}
          variant="contained"
          onClick={() => {
            setDailogueOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button
          style={{ minWidth: "7rem", background: "primary" }}
          variant="contained"
          onClick={() => {
            if (freightValue.isHazardous === "true") {
              if (location.pathname.split("/").at(-2) === "lcl") {
                console.log("hi to lcl", freightValue);
                navigate(routeConstant.LCL, {
                  state: freightValue,
                  from: "lcl",
                });
              } else {
                console.log("hi to fcl", freightValue);
                navigate(routeConstant.FCL, {
                  state: freightValue,
                  from: "fcl",
                });
              }
            } else {
              if (location.pathname.split("/").at(-2) === "lcl") {
                navigate(routeConstant.QUOTEDETAILS, {
                  state: freightValue,
                });
              } else {
                console.log("hi to fcl", freightValue);
                navigate(routeConstant.FCL_QUOTE_DETAILS, {
                  state: freightValue,
                });
              }
              // navigate(routeConstant.QUOTEDETAILS, {
              //   state: freightValue,
              // });
            }
            setDailogueOpen(false);
          }}
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
}
